import React from 'react';

import { FormControlLabel, Switch, Box, FormHelperText } from '@mui/material';

export default function Deal1031EligibleField({
  value,
  error,
  setValue,
  setError,
}) {
  return (
    <Box>
      <FormControlLabel
        control={
          <Switch
            checked={value}
            onChange={() => {
              setValue(!value);
            }}
          />
        }
        label='1031 Exchange Eligible'
      />
      <FormHelperText>
        Investors with like-kind property can exchange for this under IRC
        Section 1031.
      </FormHelperText>
    </Box>
  );
}
